const MIN_WIDTH = 150

export const TABLE_CONFIGS = [
  {
    key: 'index',
    title: '#',
    className: 'text-center',
    minWidth: 20,
  },
  {
    key: 'unit_type_id',
    title: 'Unit Type ID',
    className: '',
    minWidth: 20,
  },
  {
    key: 'unit_type_code',
    title: 'Unit Type Code',
    className: '',
    minWidth: 50,
  },
  {
    key: 'category_name',
    title: 'Category Name',
    className: '',
    minWidth: MIN_WIDTH,
  },
  {
    key: 'note',
    title: 'Note',
    className: '',
    minWidth: MIN_WIDTH,
  },
]
